// Router
import { useParams } from 'react-router-dom'

// UI
import OrderDisplay from '@/components/orders/OrderDisplay'
import ScrollableScreen from '@/components/ui/ScrollableScreen'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// React
import { useState, useEffect, useCallback } from 'react'

export default function OrderDisplayPage() {
    // Get order id from url
    const { order_id } = useParams()

    // Load order
    const { requestGet } = useAxiosApi()

    const [order, setOrder] = useState(null)

    // Sortie de l'effet pour être rejouable : lever une demande d'annulation
    // doit rafraîchir la commande sans recharger la page.
    const fetchOrder = useCallback(async () => {
        try {
            const { data } = await requestGet(`/orders/${order_id}`)

            setOrder(data)
        } catch {
            setOrder(null)
        }
    }, [order_id])

    useEffect(() => {
        if (order_id) {
            fetchOrder()
        }
    }, [order_id, fetchOrder])

    const breadcrumbs = [
        {
            label: order ? order.name : '...',
        },
    ]

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            <div className="p-5 mx-auto w-full max-w-[1000px]">
                {order && <OrderDisplay order={order} reload={fetchOrder} />}
            </div>
        </ScrollableScreen>
    )
}
